<template>
	<div class="input__wrapper">
		<label :class="data.searchLabel">
		<span class="input-label" :id="data.labelId">{{ data.label }}</span>
			<div class="input-wrap" :class="{'input-wrap--icon': data.classIcon}">
				<span :class="data.classIcon" v-if="data.classIcon">
					<SvgIcon
						class="dolar-icon"
						:iconName="data.iconName"
					/>
				</span>
				<input
					type="text"
					:id="data.inputId"
					:name="data.name"
					:placeholder="data.placeholder"
					:class="data.searchClass"
					v-model="displayValue"
					ref="searchInput"
					@blur="isInputActive = false"
					@focus="isInputActive = true"
					:disabled="isDisabled"
				/>
			</div>
		</label>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
export default {
	props: ['data', 'value', 'isDisabled'],
	components: {
		SvgIcon
	},
	data () {
		return {
			isInputActive: false,
			newValue: '',
			timeoutRef: null
		};
	},
	computed: {
		displayValue: {
			get: function() {
				if (this.isInputActive) {
					if (!this.value && this.value !== 0) {
						return '';
					} else {
						return this.value.toString();
					}
				} else {
					if (!this.value && this.value !== 0) {
						return '';
					} else {
						if (this.currency || this.data.currency) {
							return '$' + this.value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
						} else {
							return this.value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
						}
					}
				}
			},
			set: function(modifiedValue) {
				clearTimeout(this.timeoutRef);
				this.newValue = parseFloat(modifiedValue.replace(/[^\d.]/g, ''));
				if (isNaN(this.newValue)) {
					this.newValue = '';
				}
				this.timeoutRef = setTimeout(() => {
					this.$emit('input', this.newValue);
				}, 500);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.input__wrapper {
	input {
		display: block;
		box-shadow: none;
		border: 1px solid $white-lilac;
		padding: 14px 16px;
		line-height: 1.2;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		margin: 0;
		background-color: $white-lilac;

		@include mq($sm) {
			font-size: 16px;
			padding: 13px;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}

.input-wrap {
	display: flex;
}

.input-icon-box {
	background-color: $white-lilac;
	min-height: 46px;
	min-width: 47px;
	display: block;
	pointer-events: none;
	z-index: 1;
	position: relative;
	border-bottom-left-radius: 8px;
	border-top-left-radius: 8px;
}

.input-icon-box-icon {
	color: $black;
	font-size: 14px;
	height: 20px;
	z-index: 2;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	position: absolute;
}

input[type=number] {
	-moz-appearance: textfield;
}

input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

.input-wrap--icon {
	input {
		display: block;
		box-shadow: none;
		border: 1px solid $grey-light;
		padding: 18px 9px 13px;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;

		@include mq($sm) {
			font-size: 16px;
			max-width: 100%;
			padding: 13px;
		}

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}
</style>
